const getHash = async rawKey => {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(rawKey);
    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    return `SHA256:${hashArray.map(b => `00${b.toString(16)}`.slice(-2)).join('')}`;
};

export default getHash;
